import { COLORS, SCALE } from '../../constants';
import { Box } from '@material-ui/core';
import React, { useMemo } from 'react';

export const DEFAULT = [
  {
    answer: 'Less than 2 servings of fruits and 2 servings of vegetables  ',
    total: 2,
    percent: 28.57,
  },
  {
    answer: '2 servings of fruits and 2 servings of vegetables',
    total: 2,
    percent: 28.57,
  },
  {
    answer: 'More than 2 servings of fruits and 2 servings of vegetables',
    total: 3,
    percent: 42.86,
  },
];

const ListOfAnswersCom = ({ data = DEFAULT, colors = COLORS }) => {
  const listAnswers = useMemo(() => {
    return data.map((item, index) => ({
      color: item.color,
      title: item?.answer,
      value: item?.total,
    }));
  }, [data]);

  return (
    <Box display="flex" gridGap={4 * SCALE} flexDirection="column">
      {listAnswers.map((it, inx) => (
        <Box key={`${it.title}-${inx}`} display="flex" gridGap={4 * SCALE}>
          <Box
            fontFamily="OpenSans"
            fontSize={10 * SCALE}
            lineHeight={`${12 * SCALE}px`}
            borderRadius={`${4 * SCALE}px`}
            width={`${144 * SCALE}px`}
            bgcolor={'#E0E0E0'}
            px={`${8 * SCALE}px`}
            py={`${4 * SCALE}px`}
          >
            {it.title}
          </Box>
          <Box
            fontFamily="OpenSans"
            fontSize={10 * SCALE}
            lineHeight={`${18 * SCALE}px`}
            borderRadius={`${4 * SCALE}px`}
            width={`${30 * SCALE}px`}
            bgcolor={'#F5F5F5'}
            display="flex"
            justifyContent="center"
            alignItems="center"
          >
            {it.value}
          </Box>
          <Box
            borderRadius={`${4 * SCALE}px`}
            width={`${20 * SCALE}px`}
            bgcolor={it.color}
          />
        </Box>
      ))}
    </Box>
  );
};

export default ListOfAnswersCom;
